import c from 'classnames';
import { useKeenSlider } from 'keen-slider/react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { Box } from '@lyearn/ui';

import CarouselNavigation from './components/CarouselNavigation';
import CarouselNavigationShadows from './components/CarouselNavigationShadows';
import CarouselPagination from './components/CarouselPagination';
import CarouselSlides from './components/CarouselSlides';
import useCarousel from './hooks/useCarousel';
import type { CarouselProps } from './types';

const Carousel = (props: CarouselProps) => {
  const {
    className,
    classes,
    initialPage,
    spaceBetween = 0,
    pagination,
    renderPaginationArrows,
    getPaginationColor,
    navigation,
    NavigationComponent = CarouselNavigation,
    speed,
    totalCount,
    renderSlide,
    itemHeight,
    itemWidth,
    slidesPerView = 1,
    slidesPerGroupAuto = true,
    showShadows = false,
    onCreate,
    onPageChange: onPageChangeProp,
  } = props;

  const { isMobile } = useScreen();
  const { carouselState, sliderRef, onRightArrowClick, onLeftArrowClick, onPageChange } =
    useCarousel({
      initialPage,
      totalCount,
      spaceBetween,
      slidesPerGroupAuto,
      speed,
      itemWidth,
      slidesPerView,
      onCreate,
      pagination,
      navigation,
      showShadows,
      onPageChange: onPageChangeProp,
      keenSliderProps: {
        options: {
          // rtl: document?.dir === 'rtl',
          rtl: false, //temp fix: was getting document undefined error
        },
      },
    });

  return (
    <Box className={c('relative', className)}>
      <Box ref={sliderRef} className={c('keen-slider', classes?.slider)}>
        <CarouselSlides
          className={classes?.slide}
          itemHeight={itemHeight}
          itemWidth={itemWidth}
          renderSlide={renderSlide}
          totalCount={totalCount}
        />
      </Box>
      {navigation ? (
        <NavigationComponent
          className={classes?.navigationButton}
          classes={classes}
          showLeftArrow={carouselState.showLeftArrow}
          showRightArrow={carouselState.showRightArrow}
          onLeftArrowClick={onLeftArrowClick}
          onRightArrowClick={onRightArrowClick}
        />
      ) : null}
      {showShadows && !isMobile ? (
        <CarouselNavigationShadows
          showLeftShadow={carouselState.showLeftArrow}
          showRightShadow={carouselState.showRightArrow}
        />
      ) : null}
      {pagination ? (
        <CarouselPagination
          activePage={Math.ceil(carouselState.activePage)}
          className={classes?.pagination}
          getPaginationColor={getPaginationColor}
          pages={Math.ceil(carouselState.totalPages)}
          renderPaginationArrows={renderPaginationArrows}
          onChange={onPageChange}
        />
      ) : null}
    </Box>
  );
};

export { CarouselNavigation, CarouselPagination, CarouselSlides, useCarousel, useKeenSlider };

export default Carousel;
